export default "__VITE_ASSET__DZydfVzf__"